// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// filterUserList — the Users-tab search filter (#198), extracted pure so the
// case-insensitivity is regression-pinned.
//
// Prefix match (length = query length) on username, defaultCompany, or
// defaultLocation. ALL three are compared case-insensitively — the bug was that
// `username` alone was NOT lowercased, so a lowercase query never matched a
// mixed-case stored username (e.g. "JohnSarappo@kellerinteriors.com"), and the
// person couldn't be found even while logged in. An empty query returns all.
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

export function filterUserList(users, query) {
  if (!Array.isArray(users)) return [];
  const q = (query ?? "").toLowerCase();
  const queryLength = q.length;
  const querySlice = q.slice(0, queryLength);

  return users.filter((userDoc) => {
    const usernameSlice = userDoc?.username
      ?.toString()
      .toLowerCase()
      .slice(0, queryLength);
    const companySlice = userDoc?.defaultCompany
      ?.toLowerCase()
      .slice(0, queryLength);
    const locationSlice = userDoc?.defaultLocation
      ?.toLowerCase()
      .slice(0, queryLength);
    return (
      querySlice === usernameSlice ||
      querySlice === companySlice ||
      querySlice === locationSlice
    );
  });
}
